<template>
  <div class="kl-layout__container" id="app">
    <div class="flex-horizontal justify-content-end text-white" style="position: relative">
      <div class="text-center" style="position: absolute;top: 0;left: 0;z-index: -1;width: 100%;margin: 10px 0;">建议使用火狐（firefox）、谷歌（chrome）浏览器访问，以获得更佳的用户体验！</div>
      <div class="flex-horizontal" style="margin: 10px">
        <i class="k-icon el-icon-message"></i>
        <span>{{appInfo.email}}</span>
      </div>
      <div v-if="token">
        <el-button type="danger" size="mini" @click="handleLogout">退出系统</el-button>
      </div>
    </div>
    <div class="kl-main">
      <router-view/>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters(['appInfo', 'token'])
  },
  methods: {
    ...mapActions(['logout']),
    handleLogout () {
      this.$msgbox({type: 'info', title: '退出系统', message: '确定退出系统吗？', showCancelButton: true})
        .then(() => {
          this.logout()
          this.$router.replace('login')
        })
    }
  }
}
</script>

<style>

  #app {
    width: 1500px;
    margin: auto;
  }

</style>

<style scoped>
  .k-icon {
    font-size: 18px;
    margin: auto .5em;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue